<form *ngIf="form" [formGroup]="form" class="u-m-bottom--md">
	<div class="u-row u-row--sm">
		<div class="u-col-xs-8">
			<p class="u-text--bold">Secundaire begunstigde {{ index + 1 }}</p>
		</div>

		<div class="u-col-xs-4 remove-btn">
			<button (click)="removeBeneficiary()" class="c-btn-round u-m-top--mini" title="Secundaire begunstigde verwijderen" type="button">
				<span class="icon-trash"></span>
			</button>
		</div>
	</div>

	<div class="u-row u-row--sm" formGroupName="beneficiary">
		<ng-container formGroupName="organization">
			<tvcore-input [showErrors]="showErrors" class="u-col-md-8" label="Naam organisatie *" name="name" type="text">
				<tvcore-form-control-error name="required">Naam is verplicht.</tvcore-form-control-error>
			</tvcore-input>
		</ng-container>
	</div>

	<div class="u-row u-row--sm">
		<tvcore-normalized-address [group]="form.get('beneficiary.address')" [showErrors]="showErrors" class="u-col-xs-12"></tvcore-normalized-address>
	</div>

	<div class="u-row u-row--sm" formGroupName="beneficiary">
		<tvcore-input class="u-col-md-4" label="Website" name="website" type="text"></tvcore-input>
	</div>

	<div class="u-row u-row--sm">
		<ng-container formGroupName="beneficiary">
			<ng-container formGroupName="organization">
				<tvcore-input [showErrors]="showErrors" class="u-col-md-4" label="Ondernemingsnummer *" name="companyIdentification" type="text">
					<tvcore-form-control-error name="required">Ondernemingsnummer is verplicht.</tvcore-form-control-error>
					<tvcore-form-control-error name="format">Ondernemingsnummer is niet geldig.</tvcore-form-control-error>

					<p class="u-text--sm u-text--grey">Voorbeeld: 0123456789</p>
				</tvcore-input>
			</ng-container>
		</ng-container>

		<tvcore-select [options]="roles()" [showErrors]="showErrors" class="u-col-md-8" label="Type rechtsvorm *" name="roleType">
			<ng-template #optionTemplate let-option>
				{{ RELANCE_ROLE_TRANSLATIONS[option] }}
			</ng-template>

			<tvcore-form-control-error name="required">Type rechtsvorm is verplicht.</tvcore-form-control-error>
		</tvcore-select>
	</div>

	<p class="u-m-top--xxs u-m-bottom--tiny u-text--bold u-text--sm u-width--md">Omschrijf de samenwerking met de secundaire begunstigde voor de realisatie van het project en benoem de projectonderdelen die de secundaire begunstigde mee zal realiseren.</p>
	<div class="u-row u-row--sm">
		<tvcore-input
			[maxlength]="500"
			[showErrors]="showErrors"
			class="u-col-md-8"
			label="Omschrijving"
			name="roleDescription"
			type="textarea">
			<tvcore-form-control-error name="required">Omschrijving rol secundaire begunstigde is verplicht.</tvcore-form-control-error>
		</tvcore-input>
	</div>
</form>
